export const LOGIN_MODAL_NAME = 'loginFeature';
export const AUTH_OTP_CODE_MODAL_NAME = 'authOTPCode';
